export default __webpack_public_path__ + "static/media/samatur_destinos.5eb7696e.webp";